<template>
  <div class="custom-dropdown" @click="toggle" role="listbox">
    <div class="custom-dropdown__selected" ref="refSelected">
      {{ actLabelResolver(selected) }}
      <span :class="['custom-dropdown__arrow', { 'custom-dropdown__arrow--expanded': isOpen }]" />
    </div>
    <ul v-if="isOpen" class="custom-dropdown__list" v-click-outside="clickOutside">
      <li
          v-for="(option, i) in options"
          :key="i"
          class="custom-dropdown__item"
          @click.stop="select(option, i)"
          role="option"
      >
        <slot name="option" :value="option">
          {{ option }}
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      default: () => []
    },
    labelResolver: {
      type: [Function, null],
      default: null
    },
    valueResolver: {
      type: Function,
      default: (_, i) => i
    },
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    select(option, idx) {
      this.selected = this.valueResolver(option, idx)
      this.isOpen = false
    },
    actLabelResolver() {
      if (this.labelResolver) return this.labelResolver(this.selected)

      return this.selected
    },
    clickOutside(e) {
      if (e?.target === this.$refs.refSelected) return

      this.toggle()
    }
  }
}
</script>

<style lang="sass">
.custom-dropdown
  position: relative
  width: 100%
  user-select: none

  &__selected
    background: #F5F5FA
    padding: 14px 24px
    border-radius: 4px
    cursor: pointer

  &__list
    position: absolute
    top: 100%
    left: 0
    width: 100%
    background: #fff
    border-radius: 8px
    margin-top: 4px
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)
    z-index: 10

  &__item
    padding: 12px 16px
    cursor: pointer

    &:hover
      background: #f0f0f5

  &__arrow
    position: absolute
    top: calc(50% - 3px)
    right: 27px
    width: 12px
    height: 12px
    border-right: 2px solid #293045
    border-bottom: 2px solid #293045
    transform: translateY(-50%) rotate(45deg)
    pointer-events: none
    transition: transform .3s ease

    &--expanded
      transform: rotate(225deg)
</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/maxpro-dropdown.vue